import { useSelector, useDispatch } from 'react-redux';
import { 
  setUserProfile
} from '../redux/globalSlice';

export const useGlobalState = () => {
  const dispatch = useDispatch();
  const { 
    userProfile,
  } = useSelector(state => state.global);
  const updateUserProfile = (profile) => dispatch(setUserProfile(profile));
  return {
    userProfile,
    updateUserProfile,
  };
};